import { BackendInterface } from "@imagine/frontend-base";
import React from "react";

export const PhpBackendContext = React.createContext<BackendInterface | null>(
  null,
);

export const usePhpBackend = () => {
  const backend = React.useContext(PhpBackendContext);
  if (!backend) {
    throw new Error("usePhpBackend must be used within a PhpBackendProvider");
  }
  return backend;
};
